import { render, staticRenderFns } from "./FooterExterno.vue?vue&type=template&id=73c89ba4&"
import script from "./FooterExterno.vue?vue&type=script&lang=js&"
export * from "./FooterExterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports